var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62732 15.2566C3.42245 15.2566 -0.000976562 11.8332 -0.000976562 7.62829C-0.000976562 3.42343 3.42245 0 7.62732 0C11.8322 0 15.2556 3.42343 15.2556 7.62829C15.2556 11.8332 11.8322 15.2566 7.62732 15.2566ZM7.62732 1.11634C4.03272 1.11634 1.11536 4.04114 1.11536 7.62829C1.11536 11.2155 4.03272 14.1403 7.62732 14.1403C11.2219 14.1403 14.1393 11.2155 14.1393 7.62829C14.1393 4.04114 11.2219 1.11634 7.62732 1.11634Z",
    fill: "#5981E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4422 16.0006C15.3008 16.0006 15.1594 15.9485 15.0478 15.8369L13.5593 14.3485C13.3435 14.1326 13.3435 13.7754 13.5593 13.5596C13.7752 13.3437 14.1324 13.3437 14.3482 13.5596L15.8367 15.048C16.0525 15.2638 16.0525 15.6211 15.8367 15.8369C15.725 15.9485 15.5836 16.0006 15.4422 16.0006Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d13cbf14b75e1b1400b2c3b8419a9c53.svg";
export { ForwardRef as ReactComponent };